/**
 * Retorna `true` se `x` for menor ou igual a `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function lte(x, y) {
  return Number(x) <= Number(y);
}
